// // Mobile Navigation Toggle
// const navToggle = document.getElementById('nav-toggle');
// const navMenu = document.getElementById('nav-menu');

// if (navToggle && navMenu) {
//   navToggle.addEventListener('click', () => {
//     navMenu.classList.toggle('active');
//     navToggle.classList.toggle('active');
//   });

//   // Close mobile menu when clicking on a link
//   document.querySelectorAll('.nav-link').forEach(link => {
//     link.addEventListener('click', () => {
//       navMenu.classList.remove('active');
//       navToggle.classList.remove('active');
//     });
//   });
// }


// // Smooth scrolling for navigation links
// document.querySelectorAll('a[href^="#"]').forEach(anchor => {
//     anchor.addEventListener('click', function (e) {
//         e.preventDefault();
//         const target = document.querySelector(this.getAttribute('href'));
//         if (target) {
//             const headerOffset = 80;
//             const elementPosition = target.getBoundingClientRect().top;
//             const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

//             window.scrollTo({
//                 top: offsetPosition,
//                 behavior: 'smooth'
//             });
//         }
//     });
// });

// // Header background on scroll
// window.addEventListener('scroll', () => {
//     const header = document.querySelector('.header');
//     if (window.scrollY > 100) {
//         header.style.background = 'rgba(255, 255, 255, 0.98)';
//         header.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.1)';
//     } else {
//         header.style.background = 'rgba(255, 255, 255, 0.95)';
//         header.style.boxShadow = 'none';
//     }
// });

// Intersection Observer for animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.style.animationPlayState = 'running';
            entry.target.classList.add('animate');
        }
    });
}, observerOptions);

// Observe elements for animation
document.querySelectorAll('.product-card, .testimonial-card, .blog-card').forEach(card => {
    observer.observe(card);
});

// Product card interactions
document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mouseenter', () => {
        card.style.transform = 'translateY(-10px) rotateX(5deg) rotateY(5deg)';
    });

    card.addEventListener('mouseleave', () => {
        card.style.transform = 'translateY(0) rotateX(0) rotateY(0)';
    });
});

// Add to cart functionality
document.querySelectorAll('.product-btn').forEach(btn => {
    btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Add ripple effect
        const ripple = document.createElement('span');
        const rect = this.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        
        ripple.style.width = ripple.style.height = size + 'px';
        ripple.style.left = x + 'px';
        ripple.style.top = y + 'px';
        ripple.classList.add('ripple');
        
        this.appendChild(ripple);
        
        // Change button text temporarily
        const originalText = this.innerHTML;
        this.innerHTML = '<i class="fas fa-check"></i> Added!';
        this.style.background = 'linear-gradient(45deg, #059669, #047857)';
        
        setTimeout(() => {
            this.innerHTML = originalText;
            this.style.background = 'linear-gradient(45deg, #2563eb, #059669)';
            ripple.remove();
        }, 2000);
        
        // Show notification (you could replace this with a more sophisticated notification system)
        showNotification('Product added to cart!');
    });
});

// Notification system
function showNotification(message) {
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.innerHTML = `
        <i class="fas fa-check-circle"></i>
        <span>${message}</span>
    `;
    
    // Add notification styles
    Object.assign(notification.style, {
        position: 'fixed',
        top: '100px',
        right: '20px',
        background: 'linear-gradient(45deg, #059669, #047857)',
        color: 'white',
        padding: '1rem 1.5rem',
        borderRadius: '8px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        zIndex: '10000',
        transform: 'translateX(100%)',
        transition: 'transform 0.3s ease'
    });
    
    document.body.appendChild(notification);
    
    // Animate in
    setTimeout(() => {
        notification.style.transform = 'translateX(0)';
    }, 100);
    
    // Remove after 3 seconds
    setTimeout(() => {
        notification.style.transform = 'translateX(100%)';
        setTimeout(() => {
            document.body.removeChild(notification);
        }, 300);
    }, 3000);
}

// Contact form handling
// const contactForm = document.getElementById('ContactForm');
// contactForm.addEventListener('submit', function(e) {
//     e.preventDefault();
    
//     // Get form data
//     const formData = new FormData(this);
//     const data = Object.fromEntries(formData);
    
//     // Simulate form submission
//     const submitBtn = this.querySelector('button[type="submit"]');
//     const originalBtnText = submitBtn.innerHTML;
    
//     submitBtn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Sending...';
//     submitBtn.disabled = true;
    
//     setTimeout(() => {
//         submitBtn.innerHTML = '<i class="fas fa-check"></i> Sent!';
//         submitBtn.style.background = 'linear-gradient(45deg, #059669, #047857)';
        
//         // Reset form
//         this.reset();
        
//         // Show success notification
//         showNotification('Message sent successfully!');
        
//         setTimeout(() => {
//             submitBtn.innerHTML = originalBtnText;
//             submitBtn.style.background = '#ffffff';
//             submitBtn.disabled = false;
//         }, 3000);
//     }, 2000);
// });

// Form field animations
document.querySelectorAll('.form-group input, .form-group select, .form-group textarea').forEach(field => {
    field.addEventListener('focus', function() {
        this.parentElement.classList.add('focused');
    });
    
    field.addEventListener('blur', function() {
        if (!this.value) {
            this.parentElement.classList.remove('focused');
        }
    });
    
    // Check if field has value on load
    if (field.value) {
        field.parentElement.classList.add('focused');
    }
});

// Parallax effect for hero section
window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const heroVisual = document.querySelector('.hero-visual');
    const bgElements = document.querySelectorAll('.bg-element');
    
    if (heroVisual) {
        heroVisual.style.transform = `translateY(${scrolled * 0.3}px)`;
    }
    
    bgElements.forEach((element, index) => {
        const speed = (index + 1) * 0.1;
        element.style.transform = `translateY(${scrolled * speed}px) rotate(${scrolled * 0.05}deg)`;
    });
});

// Counter animation for stats
function animateCounters() {
    const counters = document.querySelectorAll('.stat h3');
    
    counters.forEach(counter => {
        const target = parseInt(counter.textContent);
        const increment = target / 100;
        let current = 0;
        
        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }
            counter.textContent = Math.floor(current) + (counter.textContent.includes('+') ? '+' : '');
        }, 20);
    });
}

// Trigger counter animation when in view
const statsObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            animateCounters();
            statsObserver.unobserve(entry.target);
        }
    });
});

const statsSection = document.querySelector('.hero-stats');
if (statsSection) {
    statsObserver.observe(statsSection);
}

// 3D tilt effect for product cards
document.querySelectorAll('.product-card').forEach(card => {
    card.addEventListener('mousemove', (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = (y - centerY) / 10;
        const rotateY = (centerX - x) / 10;
        
        card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(20px)`;
    });
    
    card.addEventListener('mouseleave', () => {
        card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) translateZ(0)';
    });
});

// Testimonials auto-rotation
let currentTestimonial = 0;
const testimonials = document.querySelectorAll('.testimonial-card');

function rotateTestimonials() {
    testimonials.forEach((testimonial, index) => {
        testimonial.style.transform = index === currentTestimonial 
            ? 'translateY(0) scale(1.05)' 
            : 'translateY(10px) scale(1)';
        testimonial.style.opacity = index === currentTestimonial ? '1' : '0.7';
    });
    
    currentTestimonial = (currentTestimonial + 1) % testimonials.length;
}

// Start testimonial rotation
if (testimonials.length > 0) {
    setInterval(rotateTestimonials, 4000);
}

// Blog card hover effects
document.querySelectorAll('.blog-card').forEach(card => {
    const image = card.querySelector('.blog-image img');
    const link = card.querySelector('.blog-link');
    
    card.addEventListener('mouseenter', () => {
        if (image) {
            image.style.transform = 'scale(1.1) rotate(2deg)';
        }
        if (link) {
            link.style.transform = 'translateX(10px)';
        }
    });
    
    card.addEventListener('mouseleave', () => {
        if (image) {
            image.style.transform = 'scale(1) rotate(0deg)';
        }
        if (link) {
            link.style.transform = 'translateX(0)';
        }
    });
});

// Add CSS for ripple effect
const style = document.createElement('style');
style.textContent = `
    .ripple {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        pointer-events: none;
        animation: ripple-animation 0.6s linear;
    }
    
    @keyframes ripple-animation {
        to {
            transform: scale(4);
            opacity: 0;
        }
    }
    
    .animate {
        animation-play-state: running;
    }
`;
document.head.appendChild(style);

console.log('AquaTech Industrial website loaded successfully!');



(function() {
    // --- everything is now in a private scope ---
    const observerOptions = {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains('member-card')) {
                    const cards = document.querySelectorAll('.member-card');
                    const index = Array.from(cards).indexOf(entry.target);
                    setTimeout(() => entry.target.classList.add('animate'), index * 200);
                }

                if (entry.target.classList.contains('stat-card')) {
                    const cards = document.querySelectorAll('.stat-card');
                    const index = Array.from(cards).indexOf(entry.target);
                    setTimeout(() => {
                        entry.target.classList.add('animate');
                        const number = entry.target.querySelector('.stat-number');
                        animateCounter(number);
                    }, index * 150);
                }

                if (entry.target.classList.contains('company-card')) {
                    const cards = document.querySelectorAll('.company-card');
                    const index = Array.from(cards).indexOf(entry.target);
                    setTimeout(() => entry.target.classList.add('animate'), index * 200);
                }

                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);

    function animateCounter(element) {
        const target = parseInt(element.getAttribute('data-target'));
        const increment = target / 100;
        let current = 0;

        const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
                current = target;
                clearInterval(timer);
            }

            const label = element.nextElementSibling.textContent;
            const shouldAddPlus = label.includes('Retailers') || label.includes('Distribution');
            const displayValue = Math.floor(current);
            element.textContent = displayValue + (shouldAddPlus ? '+' : (target >= 1000 ? '+' : ''));
        }, 20);
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.member-card, .stat-card, .company-card').forEach(el => {
            observer.observe(el);
        });

        const cta = document.querySelector('.cta-button');
        if (cta) {
            cta.addEventListener('click', (e) => {
                e.preventDefault();
                console.log('Navigate to products page');
            });
        }
    });

    window.addEventListener('scroll', () => {
        const scrolled = window.pageYOffset;
        document.querySelectorAll('.dot').forEach((dot, index) => {
            const speed = 0.5 + (index * 0.1);
            dot.style.transform = `translateY(${scrolled * speed}px) rotate(${scrolled * 0.1}deg)`;
        });
    });
})(); // <--- end private scope